import AuthGate from "./AuthGate"

export default function ProtectedRoute() {
  return <AuthGate />
}
